import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import TopUpCalcGooglePay from 'apps/auth/components/ga/accounts/topup/topUpByGoogle/TopUpCalcGooglePay';
import GooglePayButton from 'apps/auth/components/googlePay/GooglePayButton';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AMOUNT_TO } from 'apps/auth/constants/fieldsName';
import { TOP_UP_ACCOUNT } from 'apps/auth/constants/formName';

const TopUpByGooglePayPage = (props) => {
    useEffect(() => {
        window?.localStorage?.setItem('totalPrice', JSON.stringify({ value: { formattedValue: '0' } }));
    }, []);

    return (
        <CommonPage backUrl={`/auth/ga/pocket/${props.id}/top-up`} leftCloseIcon hasBottomPanel>
            <TopUpCalcGooglePay formName={TOP_UP_ACCOUNT} amount={props.totalPrice} amountFieldName={AMOUNT_TO} />
            <FixedBottomPanel>
                <GooglePayButton amount={props.totalPrice} amountField={props.amountFrom} />
            </FixedBottomPanel>
        </CommonPage>
    );
};

const mapStateToProps = (state) => {
    return {
        id: state.extra.account.id,
        amountFrom: state.form[TOP_UP_ACCOUNT].fields[AMOUNT_TO],
        totalPrice: state.form[TOP_UP_ACCOUNT].fields[AMOUNT_TO].value,
    };
};

export default connect(mapStateToProps)(BasePage(TopUpByGooglePayPage));
